import type { FC } from "react";

import type { LogoProps } from "@ui/eva-components/Logo/Logo";
import { Logo } from "@ui/eva-components/Logo/Logo";

import { ResponsiveImage } from "../ResponsiveImage/ResponsiveImage";

import styles from "./ComingSoon.module.scss";

type ImageType = {
  src: string;
  alt: string;
  title: string;
};

type BackgroundImageProps = {
  desktopImage: ImageType;
  mediumImage?: ImageType;
  smallImage?: ImageType;
  imageClassName?: string;
};

type ComingSoonProps = {
  desktopBackgroundImage: ImageType;
  tabletBackgroundImage?: ImageType;
  mobileBackgroundImage?: ImageType;
  title?: string;
  description?: string;
  subtitle?: string;
  warningBannerText?: string;
  renderBackgroundImage?: (props: BackgroundImageProps) => React.ReactNode;
  logo?: Omit<LogoProps, "isDarkMode">;
  isDarkMode?: boolean;
};

export const ComingSoon: FC<ComingSoonProps> = ({
  desktopBackgroundImage,
  tabletBackgroundImage,
  mobileBackgroundImage,
  title,
  description,
  subtitle,
  warningBannerText,
  renderBackgroundImage,
  logo,
  isDarkMode,
}) => {
  return (
    <div className={styles.wrapper}>
      {warningBannerText && <div className={styles.warningBanner}>{warningBannerText}</div>}
      {renderBackgroundImage ? (
        renderBackgroundImage({
          desktopImage: desktopBackgroundImage,
          mediumImage: tabletBackgroundImage,
          smallImage: mobileBackgroundImage,
        })
      ) : (
        <ResponsiveImage
          largeSrc={desktopBackgroundImage?.src}
          mediumSrc={tabletBackgroundImage?.src}
          smallSrc={mobileBackgroundImage?.src}
          className={styles.image}
        />
      )}
      <div className={styles.subcontent}>
        {logo?.srcDark && logo?.srcLight ? (
          <Logo isDarkMode={isDarkMode ?? false} {...logo} className={styles.customLogo} />
        ) : (
          <p className={styles.subtitle}>{subtitle}</p>
        )}
      </div>
      <div className={styles.innerWrapper}>
        {title && <p className={styles.title}>{title}</p>}
        {description && <p className={styles.description}>{description}</p>}
      </div>
    </div>
  );
};
